import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBasedQuery';
import { HTTP_METHODS } from '../../utils/handler';
import { API_BASE_URL } from '../../config';

const { GET } = HTTP_METHODS;

export const googleCalendarApi = createApi({
  reducerPath: 'googleCalendarApi',
  baseQuery: axiosBaseQuery({ baseUrl: API_BASE_URL, credentials: true }),
  endpoints: (builder) => ({
    googleCalendarAuth: builder.mutation({
      query: () => ({ url: '/google-calendar/auth/google', method: GET })
    }),
    getGoogleEvents: builder.query({
      query: (payload = {}) => ({
        url: '/google-calendar/events',
        method: GET,
        params: {
          timeMin: payload.timeMin,
          timeMax: payload.timeMax
        }
      })
    }),
    disconnectGoogleCalendar: builder.mutation({
      query: () => ({
        url: '/google-calendar/disconnect',
        method: GET
      })
    })
  })
});

export const {
  useGoogleCalendarAuthMutation,
  useGetGoogleEventsQuery,
  useDisconnectGoogleCalendarMutation
} = googleCalendarApi;
